/**
 * Copyright (c) 2019-2021 2022 AIGIA All Rights Reserved.
 */

"use strict";

import {Directive, EventEmitter, Input, Output} from "@angular/core";

/**
 * todo
 */
@Directive()

export abstract class FloatingComponent {

	@Input() public position: any = {x: 0, y: 0};
	@Input() public visible: boolean;
	@Input() public active: boolean;
	@Input() public layout: any;

	@Output() public visibleChange = new EventEmitter<boolean>();
	@Output() public dragEnd = new EventEmitter<any>();
	@Output() public mouseDown = new EventEmitter<any>();

	/**
	 * @returns none
	 */
	public _visible(): { display: string } {
		let visibility_value: string = "block";
		if (!this.visible) {
			visibility_value = "none";
		}
		return {display: visibility_value};
	}

	/**
	 * @returns none
	 */
	public _visibleChange(show: boolean): void {
		this.visibleChange.emit(show);
	}

	/**
	 * @returns none
	 */
	public _dragEnd(event: any): void {
		this.position = {x: this.position.x + event.distance.x, y: this.position.y + event.distance.y};
		this.dragEnd.emit(this.position);
	}

	/**
	 * @returns none
	 */
	public _mouseDown(event: any): void {
		this.mouseDown.emit(event);
	}

	/**
	 * @returns none
	 */
	public _active(): boolean {
		return this.active;
	}

	// 10 + this.size[0] + "px"
	public styleSize(width: string = "fit-content", height: string = "fit-content"): any {
		return {width: width, height: height};
	}

}
